import { Table } from "@mantine/core";
import HomePageTable from "./HomePageTableComponent";
import dayjs from "dayjs";
import { dateWithHourFormat } from "../../../utils/dateFormat";

const LatestRuleChangesTable = ({ items }) => {
  const rows = items.map((item, i) => (
    <Table.Tr key={`${item.userName}-${i}`}>
      <Table.Td>{item.ruleName}</Table.Td>
      <Table.Td>{item.status}</Table.Td>
      <Table.Td>{dayjs(item.date).format(dateWithHourFormat)}</Table.Td>
      <Table.Td>{item.userName}</Table.Td>
    </Table.Tr>
  ));

  return (
    <HomePageTable>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Rule Name</Table.Th>
          <Table.Th>Status</Table.Th>
          <Table.Th>Date</Table.Th>
          <Table.Th>Name</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>{rows}</Table.Tbody>
    </HomePageTable>
  );
};

export default LatestRuleChangesTable;
